<template>
  <div class="d-flex-column space-between align-start testimonial_card">
    <div
      class="content_area d-flex-column justify-start align-start"
      v-if="getActiveTestimonial.orderDetails"
    >
      <div
        class="d-flex-row justify-start gap-24"
        v-if="getActiveTestimonial.packImage"
      >
        <img
          :src="getActiveTestimonial.packImage"
          alt="Active card image"
          height="60"
          width="60"
        />
        <div
          class="d-flex-column align-start gap-10"
          v-if="getActiveTestimonial.packType"
        >
          <label class="medium-l f-w-700 t-white font-family-2">{{
            getActiveTestimonial.packType
          }}</label>

          <div
            class="d-flex-row justify-start"
            v-if="getActiveTestimonial.gameImage"
          >
            <img
              :src="getActiveTestimonial.gameImage"
              alt="Active card image"
              height="25"
              width="25"
            />
            <label class="t-light regular-l f-w-400 font-family-2">{{
              getActiveTestimonial.game
            }}</label>
          </div>
        </div>
      </div>
      <hr class="horizontal" />

      <div
        class="d-flex-column order_details gap-5"
        v-if="getActiveTestimonial.orderDetails"
      >
        <div
          class="d-flex-row space-between"
          v-for="(key, value) in getActiveTestimonial.orderDetails"
        >
          <div
            class="d-flex-row space-between"
            v-if="
              (value === 'currentRank' ||
                value === 'desiredRank' ||
                value === 'rank') &&
              key?.title
            "
          >
            <p class="regular-m t-light font-family-2">
              {{ $t(`order.card.${value}`) }}
            </p>
            <p
              class="d-flex-row justify-end flex-5 t-white font-family-2 bold-l"
            >
              {{ key.title }}
              <img
                :src="key.image_dark"
                alt="Game rank icon"
                class="card_rank_icon"
                height="24"
                width="24"
              />
            </p>
          </div>
          <div
            class="d-flex-row space-between"
            v-else-if="value === 'currentTier' || value === 'desiredTier'"
          >
            <p class="regular-m t-light font-family-2">
              {{ $t(`order.card.${value}`) }}
            </p>
            <p
              class="d-flex-row justify-end flex-5 t-white font-family-2 bold-l"
            >
              {{ key.title }}
              <img
                :src="key.icon"
                alt="Game rank icon"
                class="card_rank_icon"
                height="24"
                width="24"
              />
            </p>
          </div>

          <div
            class="d-flex-row space-between"
            v-else-if="
              value === 'faceitCurrentDivision' ||
              value === 'faceitDesiredDivision'
            "
          >
            <p class="regular-m t-light font-family-2">
              {{ $t(`order.card.${value}`) }}
            </p>
            <p
              class="d-flex-row justify-end flex-5 t-white font-family-2 bold-l"
            >
              {{ key.title }}
              <img
                :src="key.icon"
                alt="Game rank icon"
                class="card_rank_icon"
                height="24"
                width="24"
              />
            </p>
          </div>

          <div
            class="d-flex-row space-between"
            v-else-if="value === 'soulFighterRank'"
          >
            <p class="regular-m t-light font-family-2">
              {{ $t(`order.card.${value}`) }}
            </p>
            <p
              class="d-flex-row justify-end flex-5 t-white font-family-2 bold-l"
            >
              {{ key.title }}
              <img
                :src="key.icon"
                alt="Game rank icon"
                class="card_rank_icon"
                height="24"
                width="24"
              />
            </p>
          </div>

          <div
            class="d-flex-row space-between"
            v-if="
              value === 'numberOfGames' ||
              value === 'numberOfWins' ||
              value === 'numberOfHours' ||
              value === 'vodReviews' ||
              value === 'currentMmr' ||
              value === 'desiredMmr'
            "
          >
            <p class="regular-m t-light font-family-2">
              {{ $t(`order.card.${value}`) }}
            </p>
            <p
              class="d-flex-row justify-end flex-5 t-white font-family-2 bold-l"
            >
              {{ key }}
            </p>
          </div>
          <div class="d-flex-row space-between" v-if="value === 'eLearning'">
            <p class="regular-m t-light font-family-2">
              {{ $t(`order.card.${value}`) }}
            </p>
            <p
              class="d-flex-row justify-end flex-5 t-white font-family-2 bold-l"
              v-if="key.includes('')"
            >
              {{ $t(key) }}
            </p>
            <p
              class="d-flex-row justify-end flex-5 t-white font-family-2 bold-l"
              v-else
            >
              {{ key }}
            </p>
          </div>
        </div>
        <div
          class="d-flex-row space-between"
          v-if="getActiveTestimonial.orderPlatform"
        >
          <p class="regular-m t-light font-family-2">
            {{ $t(`order.card.platform`) }}
          </p>
          <p class="d-flex-row justify-end flex-5 t-white font-family-2 bold-l">
            {{ getActiveTestimonial.orderPlatform.title }}
            <img
              :src="getActiveTestimonial.orderPlatform.image_dark"
              alt="Game platform icon"
              class="card_rank_icon"
              height="24"
              width="24"
            />
          </p>
        </div>
      </div>
      <hr class="horizontal" />
    </div>

    <div class="d-flex-column justify-start align-start gap-15">
      <p class="t-white font-family-2 medium-xxl">
        {{ getActiveTestimonial.review }}
      </p>
      <label class="t-grey font-family-2 regular-l">{{
        censorName(getActiveTestimonial.user)
      }}</label>
    </div>

    <div class="d-flex-row justify-start reviewers" v-dragscroll="true">
      <div class="reviewer" v-for="(testimonial, index) in testimonials">
        <img
          :src="testimonial.reviewer_avatar"
          :key="testimonial"
          alt="Reviewer avatar"
          class="reviewer_avatar"
          height="40"
          width="40"
          @click="selectAvatar(index)"
        />
        <div
          class="progress"
          ref="progress"
          v-if="index === activeTestmionial"
        ></div>
      </div>
    </div>
  </div>
</template>

<script>
import { dragscroll } from "vue-dragscroll";
import OrderDetail from "../common/table/OrderDetail.vue";

export default {
  data() {
    return {
      activeTestmionial: 0,
      interval: null,
      intervalId: null,
    };
  },
  props: {
    testimonials: {
      default: [],
    },
  },

  computed: {
    getActiveTestimonial() {
      const review = this.testimonials[this.activeTestmionial];
      if (review) {
        return {
          review: review.review,
          user: review.reviewer_username,
          packImage: review?.game_pack_image || null,
          packType: review?.game_pack || null,
          orderDetails: review?.order_details || null,
          orderPlatform: review?.order_platform || null,
          gameImage: review?.game_image || null,
          game: review?.game || null,
        };
      }
      return {
        review: "",
        user: "",
      };
    },
    name() {
      return "test";
    },
  },
  components: {
    OrderDetail,
  },

  directives: {
    dragscroll,
  },
  methods: {
    selectAvatar(index) {
      this.activeTestmionial = index;
    },
    censorName(name) {
      if (!name) return ""; // Handle empty or undefined values
      return name.slice(0, 4) + "*".repeat(Math.max(0, name.length - 4));
    },
    moveItems() {
      let currentPercentage = 0;
      const changePerSecond = 100 / 2300;

      this.intervalId = setInterval(() => {
        currentPercentage += changePerSecond;
        currentPercentage = Math.min(currentPercentage, 100);

        if (this.$refs["progress"]) {
          if (this.$refs["progress"][0]?.style) {
            this.$refs["progress"][0].style = `--i: ${currentPercentage}%`;
          }
        }

        if (currentPercentage >= 100) {
          clearInterval(this.intervalId);
        }
      }, 1);
    },

    clearInt() {
      if (this.interval) {
        clearInterval(this.interval);
      }
    },
    createInt() {
      this.interval = setInterval(() => {
        this.moveNext();
      }, 10000);
    },
    selectIndex(index) {
      this.clearInt();
      this.activeTestmionial = index;
      this.createInt();
    },

    setIndex(index) {
      this.activeTestmionial = index;
    },

    moveNext() {
      if (this.activeTestmionial === this.testimonials.length - 1) {
        this.setIndex(0);
        return;
      }
      this.setIndex(this.activeTestmionial + 1);
    },
  },

  mounted() {
    this.createInt();
    // this.moveItems();
    this.moveItems();
  },

  beforeUnmount() {
    this.clearInt();
  },
  watch: {
    activeTestmionial() {
      clearInterval(this.intervalId);
      this.moveItems();
    },
  },
};
</script>
